module.exports = __webpack_public_path__ + "img/logo-asli.64a7d1de.png";